import React from "react";
import PropTypes from "prop-types";
import styled from "react-emotion";

class Option extends React.Component {
  handleChange = () => {
    const { value, label } = this.props;
    const { selectedValue, onChange, close } = this.context.selectGroup;
    if (value === selectedValue) {
      close();
    } else {
      onChange(value, label);
    }
  };
  render() {
    const { value, label, className = "" } = this.props;
    const { selectedValue, selectedClass, hasImg } = this.context.selectGroup;
    const selected = value === selectedValue;
    const selectedClassName = selected ? selectedClass : "";
    return (
      <ListItem
        className={`select-option ${className} ${selectedClassName}`}
        hasImg={hasImg}
        onClick={this.handleChange}
      >
        {label}
      </ListItem>
    );
  }
}
Option.propTypes = {
  className: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.string.isRequired,
};

Option.contextTypes = {
  selectGroup: PropTypes.object
};

export default Option;


const ListItem = styled("div")`
  padding-left: 22px;
  ${props => props.hasImg ? `
    padding-left: 55px;
  ` : null};
`;



// WEBPACK FOOTER //
// ./src/components/form/select/Option.jsx